import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CheckIcon from '@material-ui/icons/Check';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SettingsIcon from '@material-ui/icons/Settings';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ScreenLockPortraitIcon from '@material-ui/icons/ScreenLockPortrait';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import { PopupMenu, Permissions, User, addCommonPortalMenuItems } from 'react-frontend-utils'
import { PP } from '../models/PP'
import { Pages } from '../routes/Home'


/**
 *  The MainMenu component provides a dropdown menu for use in the AppBar. The selections are based on the available choices
 *  in the Pages object in Home. 
 *  
 *  The parent component MUST pass in a prop called selectPageCallback which is a function that takes a parameter which is one of
 *  a Pages object.  The callback is invoked with the user selects one of the menu items.
 * 
 *  The parent component CAN set a prop called currentPage which is one of the Pages items indicating the currently displayed page.
 *  This will show in the menu as the selected item. If nothing is selected
 * 
 */


export function MainMenu(props) {
    

    const menuIcon = ( <MenuIcon /> );
    const checkIcon = (<CheckIcon fontSize="small"/>);
    const cloudIcon = (<CloudQueueIcon fontSize="small"/>);
    const manualIcon = (<MenuBookIcon fontSize="small"/>);
    const settingsIcon = (<SettingsIcon fontSize="small"/>);
    const appsIcon = (<ScreenLockPortraitIcon fontSize="small"/>);
    const marketplaceIcon = (<ShoppingCartIcon fontSize="small"/>);
    const billingIcon = (<MonetizationOnOutlinedIcon fontSize="small"/>);
    const financialsIcon = (<AccountBalanceIcon fontSize="small"/>);
    
    const items = (() => {
        
        let menuItems = [];
        
        //---------------------- STANDARD POOL PASS ITEMS----------------------------------

        
        menuItems.push({label: "Access Database", 
                        icon: checkIcon, 
                        isSelected: (props.currentPage === Pages.POOLPASS), 
                        selectCallback: () => props.selectPageCallback(Pages.POOLPASS)}
                       );
        
        if (PP.user.databases.length > 1) {
            menuItems.push({label: "Select Database", 
                            icon: cloudIcon, 
                            isSelected: (props.currentPage === Pages.SWITCH_DATABASE),
                            selectCallback: () => props.selectPageCallback(Pages.SWITCH_DATABASE)}
                            );
        }
        
        menuItems.push({label: "Preferences", 
                        icon: settingsIcon, 
                        isSelected: (props.currentPage === Pages.PREFERENCES), 
                        selectCallback: () => props.selectPageCallback(Pages.PREFERENCES)}
                       );
               
        menuItems.push(null);
        
        //---------------------------- ADVANCED POOLPASS ------------------------------------------
         
        let addDivider = false;

        if (PP.user.isSuperAdmin() || PP.user.role === User.Role.AGENT) {

            menuItems.push({label: "Manage Apps", 
                            icon: appsIcon, 
                            isSelected: (props.currentPage === Pages.MANAGE_APPS), 
                            selectCallback: () => props.selectPageCallback(Pages.MANAGE_APPS)}
                           );
            addDivider = true;
        }
        
        
        if (PP.user.hasPermissionTo(Permissions.SIMPLE_MARKETPLACE_MANAGE)) {

            menuItems.push({label: "Manage Marketplace", 
                    icon: marketplaceIcon, 
                    isSelected: (props.currentPage === Pages.MANAGE_MARKETPLACE), 
                    selectCallback: () => props.selectPageCallback(Pages.MANAGE_MARKETPLACE)}
                   );
           
            addDivider = true;
        }
        
        if (PP.user.hasPermissionTo(Permissions.VIEW_INVOICES)) {

            menuItems.push({label: "Membership Billing", 
                    icon: billingIcon, 
                    isSelected: (props.currentPage === Pages.BILLING), 
                    selectCallback: () => props.selectPageCallback(Pages.BILLING)}
                   );
            addDivider = true;
                   
        }

        if (PP.user.isSuperAdmin()) {
            menuItems.push(null);
         
            menuItems.push({label: "Financials", 
                  icon: financialsIcon, 
                  isSelected: (props.currentPage === Pages.FINANCIALS), 
                  selectCallback: () => props.selectPageCallback(Pages.FINANCIALS)}
                 );         
         
            addDivider = true;
        }

        
        if (addDivider)
            menuItems.push(null);
        
        //---------------------------- EVERYONE ------------------------------------------
               
        addCommonPortalMenuItems(menuItems, PP.user, "membership");

        menuItems.push(null);       
        menuItems.push({label: "Online Manual", 
                        icon: manualIcon, 
                        isSelected: (props.currentPage === Pages.HELP), 
                        selectCallback: () => props.selectPageCallback(Pages.HELP)}
                       );
        
        return menuItems;
    })();

    return (

        <PopupMenu menuIcon={menuIcon} menuItems={items} lighterHover={true}/>
         
    );
    
   
}

